import React, { useState, useEffect } from 'react';
import {
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Tab,
  Box,
  IconButton,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Snackbar,
  Alert,
  TablePagination,
  TextField,
  InputAdornment,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  useTheme,
  useMediaQuery,
  Grid
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import PhoneIcon from '@mui/icons-material/Phone';
import PhoneDisabledIcon from '@mui/icons-material/PhoneDisabled';
import CallMadeIcon from '@mui/icons-material/CallMade';
import PillComponent from '../customcomponents/CustomPillComponent';
import SearchInput from '../customcomponents/CustomSearchInput';
import SelectInput from '../customcomponents/CustomSelectInput';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import { useNavigate } from 'react-router-dom';
import api from '../api';

// Tab Panel Component
function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`call-tabpanel-${index}`}
      aria-labelledby={`call-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function mapAndCategorizeCalls(calls) {
  const received = [];
  const dialed = [];
  const missed = [];

  if (!Array.isArray(calls)) {
    return { received, dialed, missed };
  }

  // First, map all calls and include the raw date for sorting
  console.log('jasheer',calls)
  const allCalls = calls
    .filter(call => call) // Remove any null/undefined calls
    .map(call => {
      // Determine call status based on call type and duration
      let callStatus = 'unknown';
      let rawDuration = 0;

      if (call.TA_Call_Duration) {
        rawDuration = call.TA_Call_Duration;
      }

      if(call.TA_Call_Type === 1){
        callStatus = 'completed';
      }
      // For missed calls (type === '3'), always show as "missed"
      if (call.TA_Call_Type === 3) {
        callStatus = 'missed';
      } 
      // for dialed calls always show connected
      else if (call.TA_Call_Type === 2) {
        callStatus = 'connected';
      }
      else if (call.TA_Call_Duration) {
        if (rawDuration == '00:00:00') {
          callStatus = 'not connected';
        } else {
          callStatus = 'connected';
        }
      } else {
        // Fallback to original status if available
        callStatus = call.TA_Call_Status || 'unknown';
      }
      return {
        id: call._id,
        patient: call.TA_Caller_Name || '',
        phone: call.TA_Caller_Number || '',
        service: call.TA_Device_ID || 'N/A',
        duration: call.TA_Call_Type === 3 ? '00:00:00' : (call.TA_Call_Duration ? `${call.TA_Call_Duration} sec` : 'N/A'),
        rawDuration: rawDuration,
        date: call.TA_Call_TimeStamp ? new Date(call.TA_Call_TimeStamp).toLocaleString() : 'N/A',
        type: call.TA_Call_Type || '1',
        status: callStatus,
        receiverNumber: call.TA_Receiver_Number || 'N/A',
        synced: call.TA_Synced === '1' ? 'Yes' : 'No',
        // Add raw date for sorting
        rawDate: call.TA_Call_Date ? new Date(call.TA_Call_Date) : new Date(0)
      };
    })
    // Sort by rawDate in descending order (newest first)
    // .sort((a, b) => b.rawDate - a.rawDate);

  // Categorize the sorted calls
  for (const call of allCalls) {
    if (call.type === 1) {
      received.push(call);
    } else if (call.type === 2) {
      dialed.push(call);
    } else if (call.type === 3) {
      missed.push(call);
    } else {
      // Default to received for unknown types
      received.push(call);
    }
  }

  return { received, dialed, missed };
}

function CallLogsPage() {
  const navigate = useNavigate();
  const [tabValue, setTabValue] = useState(0);
  const [showWhatsAppDialog, setShowWhatsAppDialog] = useState(false);
  const [selectedCall, setSelectedCall] = useState(null);
  const [receivedCalls, setReceivedCalls] = useState([]);
  const [dialedCalls, setDialedCalls] = useState([]);
  const [missedCalls, setMissedCalls] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  // Pagination and search state
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('All');
  const theme = useTheme();
  const isSmallScreen = useMediaQuery('(max-width:800px)');

  // Handle search
  const handleSearch = (event) => {
    setSearchTerm(event.target.value.toLowerCase());
    setPage(0); // Reset to first page on new search
  };

  // Handle status filter change
  const handleStatusFilterChange = (event) => {
    setStatusFilter(event.target.value);
    setPage(0); // Reset to first page on filter change
  };

  // Handle clear filters
  const handleClearFilters = () => {
    setSearchTerm('');
    setStatusFilter('All');
    setPage(0); // Reset to first page when clearing filters
  };

  // Filter calls based on search term and status filter
  const filterCalls = (calls) => {
    let filtered = calls;

    // Apply status filter first
    if (statusFilter !== 'All') {
      filtered = filtered.filter(call => call.status === statusFilter);
    }

    // Then apply search term filter
    if (searchTerm) {
      filtered = filtered.filter(call =>
        (call.patient && call.patient.toLowerCase().includes(searchTerm)) ||
        (call.phone && call.phone.includes(searchTerm)) ||
        (call.receiverNumber && call.receiverNumber.includes(searchTerm)) ||
        (call.service && call.service.toLowerCase().includes(searchTerm)) ||
        (call.status && call.status.toLowerCase().includes(searchTerm))
      );
    }

    return filtered;
  };

  // Helper to get paginated and filtered data
  const getPaginatedRows = (rows) => {
    const filteredRows = filterCalls(rows);
    return filteredRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  };

  // Get total count after filtering
  const getFilteredCount = (rows) => filterCalls(rows).length;

  useEffect(() => {
    const fetchCalls = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await api.get('/calls');
        console.log('API Response:', res);

        if (res.data && Array.isArray(res.data)) {
          const { received, dialed, missed } = mapAndCategorizeCalls(res.data);
          setReceivedCalls(received);
          setDialedCalls(dialed);
          setMissedCalls(missed);
        } else if (res.data && res.data.data && Array.isArray(res.data.data)) {
          // Fallback for different response format
          const { received, dialed, missed } = mapAndCategorizeCalls(res.data.data);
          setReceivedCalls(received);
          setDialedCalls(dialed);
          setMissedCalls(missed);
        } else {
          console.warn('Unexpected API response format:', res);
          setReceivedCalls([]);
          setDialedCalls([]);
          setMissedCalls([]);
        }
      } catch (err) {
        setError('Failed to fetch calls');
        setReceivedCalls([]);
        setDialedCalls([]);
        setMissedCalls([]);
      } finally {
        setLoading(false);
      }
    };
    fetchCalls();
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Reset pagination when tab changes
  useEffect(() => {
    setPage(0);
  }, [tabValue]);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleShowTicket = (row) => {
    navigate(`/ticket/${encodeURIComponent(row.phone)}`);
  };

  const handleWhatsAppClick = (call) => {
    setSelectedCall(call);
    setShowWhatsAppDialog(true);
  };

  const handleSendWhatsApp = async () => {
    if (!selectedCall) return;
    try {
      // Trim country code and non-digit prefix, keep last 10 digits
      let rawPhone = selectedCall.phone || '';
      // Remove all non-digit characters
      rawPhone = rawPhone.replace(/\D/g, '');
      // Use last 10 digits
      const trimmedPhone = rawPhone.slice(-10);
      // Prepare patient payload
      const payload = {
        TA_Patient_Name: selectedCall.patient,
        TA_Patient_Mobile_Number: trimmedPhone,
        TA_Patient_Email_Address: '',
        TA_Patient_Age: 0,
        TA_Source_Type: 1 // or another default/source
      };
      const res = await api.post('/patients', payload);
      if (res.data && res.data.success) {
        setSnackbar({ open: true, message: 'Whatsapp message sent', severity: 'success' });

        // Delay navigation by 2 seconds (2000 ms)
        setTimeout(() => {
          navigate('/interactions-new');
        }, 1500);
      } else {
        setSnackbar({ open: true, message: 'Failed to create patient', severity: 'error' });
      }
    } catch (err) {
      setSnackbar({ open: true, message: 'Failed to create patient', severity: 'error' });
    } finally {
      setShowWhatsAppDialog(false);
      setSelectedCall(null);
    }
  };
  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setSnackbar({ ...snackbar, open: false });
  };

  const handleCancelWhatsApp = () => {
    setShowWhatsAppDialog(false);
    setSelectedCall(null);
  };

  const renderCallTable = (calls, showDuration = true) => {
    const filteredCalls = filterCalls(calls);
    const paginatedCalls = getPaginatedRows(filteredCalls);

    return (
      <>
        
        {
          isSmallScreen ? (
            <>
              <Grid container spacing={2}>
                {paginatedCalls.map((call, index) => (
                  <Grid item xs={12} key={call.id}>
                    <Paper
                      elevation={2}
                      sx={{
                        borderRadius: 3,
                        p: 2,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 1.5,
                        boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
                        position: 'relative',
                      }}
                    >
                      {/* SL No. in light gray with # at top */}
                      <Box
                        sx={{
                          display:'flex',
                          justifyContent:'end',
                          color: '#b0b0b0',
                          fontWeight: 700,
                          fontSize: 18,
                          letterSpacing: 1,
                          width:'100%'
                        }}
                      >
                        #{page * rowsPerPage + index + 1}
                      </Box>

                      {/* Caller Name */}
                      <Box sx={{ display: 'flex', gap: 1 }}>
                        <Typography variant="subtitle2" sx={{ color: 'background.text', fontWeight: 500 }}>
                          Caller Name:
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ color: 'background.text', textTransform: 'capitalize', fontWeight: 700 }}
                        >
                          {call.patient}
                        </Typography>
                      </Box>

                      {/* Caller Number */}
                      <Box sx={{ display: 'flex', gap: 1 }}>
                        <Typography variant="body2" sx={{ color: 'background.text', fontWeight: 500 }}>
                          Caller Number:
                        </Typography>
                        <Typography variant="body2" sx={{ color: 'background.text', fontWeight: 600 }}>
                          {call.phone}
                        </Typography>
                      </Box>

                      {/* Receiver Number */}
                      <Box sx={{ display: 'flex', gap: 1 }}>
                        <Typography variant="body2" sx={{ color: 'background.text', fontWeight: 500 }}>
                          Receiver Number:
                        </Typography>
                        <Typography variant="body2" sx={{ color: 'background.text', fontWeight: 600 }}>
                          {call.receiverNumber}
                        </Typography>
                      </Box>

                      {/* Device ID */}
                      <Box sx={{ display: 'flex', gap: 1 }}>
                        <Typography variant="body2" sx={{ color: 'background.text', fontWeight: 500 }}>
                          Device ID:
                        </Typography>
                        <Typography variant="body2" sx={{ color: 'background.text', fontWeight: 600 }}>
                          {call.service}
                        </Typography>
                      </Box>

                      {/* Duration (conditional) */}
                      {(tabValue === 0 || tabValue === 2) && (
                        <Box sx={{ display: 'flex', gap: 1 }}>
                          <Typography variant="body2" sx={{ color: 'background.text', fontWeight: 500 }}>
                            Duration:
                          </Typography>
                          <Typography variant="body2" sx={{ color: 'background.text', fontWeight: 600 }}>
                            {call.duration}
                          </Typography>
                        </Box>
                      )}

                      {/* Status (conditional) */}
                      {(tabValue === 0 || tabValue === 2) && (
                        <Box sx={{ display: 'flex', gap: 1 }}>
                          <Typography variant="body2" sx={{ color: 'background.text', fontWeight: 500 }}>
                            Status:
                          </Typography>
                          <Box
                            sx={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              px: 1.5,
                              py: 0.5,
                              borderRadius: 1,
                              bgcolor:
                                call.status === 'completed'
                                  ? 'success.light'
                                  : call.status === 'missed'
                                  ? 'error.light'
                                  : call.status === 'connected'
                                  ? 'success.main'
                                  : call.status === 'not connected'
                                  ? 'error.dark'
                                  : 'warning.light',
                              color: 'common.white',
                              fontWeight: 500,
                              fontSize: '0.75rem',
                              textTransform: 'capitalize',
                            }}
                          >
                            {call.status}
                          </Box>
                        </Box>
                      )}

                      {/* Date & Time */}
                      <Box sx={{ display: 'flex', gap: 1 }}>
                        <Typography variant="body2" sx={{ color: 'background.text', fontWeight: 500 }}>
                          Date &amp; Time:
                        </Typography>
                        <Typography variant="body2" sx={{ color: 'background.text', fontWeight: 600 }}>
                          {call.date}
                        </Typography>
                      </Box>

                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        {/* Synced */}
                        <Box sx={{ display: 'flex', gap: 1 }}>
                          <Typography variant="body2" sx={{ color: 'background.text', fontWeight: 500 }}>
                            Synced:
                          </Typography>
                          <Typography variant="body2" sx={{ color: 'background.text', fontWeight: 600 }}>
                            {call.synced}
                          </Typography>
                        </Box>

                        {/* Actions (right-aligned) */}
                        <Box display="flex" alignItems="center" gap={1}>
                          <Tooltip title="Send WhatsApp">
                            <IconButton
                              size="small"
                              sx={{
                                borderRadius: '50%',
                                boxShadow: '0 2px 8px 0 rgba(37,211,102,0.10)',
                                background: '#e9f9ef',
                                transition: 'box-shadow 0.25s, background 0.25s, transform 0.25s',
                                color: '#25D366',
                                '&:hover': {
                                  background: '#25D366',
                                  color: '#fff',
                                  boxShadow: '0 4px 16px 0 rgba(37,211,102,0.20)',
                                  transform: 'scale(1.12)',
                                },
                              }}
                              onClick={() => handleWhatsAppClick(call)}
                            >
                              <WhatsAppIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </Box>
                    </Paper>
                  </Grid>
                ))}
              </Grid>

            </>
          ) : (
            <>  
              <TableContainer sx={{ borderRadius: 3 }}>
                <Table>
                  <TableHead>
                    <TableRow sx={{ bgcolor: 'primary.main' }}>
                      <TableCell sx={{ fontWeight: 600, color: 'white' }}>Caller Name</TableCell>
                      <TableCell sx={{ fontWeight: 600, color: 'white' }}>Caller Number</TableCell>
                      <TableCell sx={{ fontWeight: 600, color: 'white' }}>Receiver Number</TableCell>
                      <TableCell sx={{ fontWeight: 600, color: 'white' }}>Device ID</TableCell>
                      {(tabValue === 0 || tabValue === 2) && (
                      <TableCell sx={{ fontWeight: 600, color: 'white' }}>Duration</TableCell>
                      )}
                      {/* <TableCell sx={{ fontWeight: 600, color: 'white' }}>Status</TableCell> */}
                      {(tabValue === 0 || tabValue === 2) && (
                        <TableCell sx={{ fontWeight: 600, color: 'white' }}>Status</TableCell>
                      )}
                      <TableCell sx={{ fontWeight: 600, color: 'white' }}>Date & Time</TableCell>
                      <TableCell sx={{ fontWeight: 600, color: 'white' }}>Synced</TableCell>
                      <TableCell sx={{ fontWeight: 600, color: 'white' }}>Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {paginatedCalls.length > 0 ? paginatedCalls.map((call) => (
                      <TableRow key={call.id} hover>
                        <TableCell>
                          <Typography variant="subtitle2" fontWeight={600} sx={{ color: 'background.text' }}>
                            {call.patient}
                          </Typography>
                        </TableCell>
                        <TableCell sx={{ color: 'background.text' }}>{call.phone}</TableCell>
                        <TableCell sx={{ color: 'background.text' }}>{call.receiverNumber}</TableCell>
                        <TableCell sx={{ color: 'background.text' }}>{call.service}</TableCell>
                        {(tabValue === 0 || tabValue === 2) && (
                        <TableCell sx={{ color: 'background.text' }}>{call.duration}</TableCell>
                      )}
                          {(tabValue === 0 || tabValue === 2) && (
                            <TableCell sx={{ color: 'background.text' }}>
                              <PillComponent status={call.status} />
                            </TableCell>
                          )}
                        <TableCell sx={{ color: 'background.text' }}>{call.date}</TableCell>
                        <TableCell sx={{ color: 'background.text' }}>{call.synced}</TableCell>
                          <TableCell>
                          <Box sx={{ display: 'flex', gap: 1 }}>
                            <Tooltip title="Send WhatsApp">
                              <IconButton
                                size="small"
                                sx={{
                                  bgcolor: '#25D366',
                                  color: '#fff',
                                  '&:hover': { bgcolor: '#1ebe57' },
                                }}
                                onClick={() => handleWhatsAppClick(call)}
                              >
                                <WhatsAppIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </Box>
                        </TableCell>
                      </TableRow>
                    )) : (
                      <TableRow>
                        <TableCell colSpan={9} align="center" sx={{ py: 3 }}>
                          <Typography variant="body1" color="background.text">
                            No matching calls found
                          </Typography>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25, 50]}
                  component="div"
                  count={filteredCalls.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  sx={{
                    '& .MuiTablePagination-toolbar': {
                      padding: '8px 16px',
                    },
                    '& .MuiTablePagination-displayedRows, & .MuiTablePagination-selectLabel': {
                      // marginBottom: 0,
                    },
                    color: 'background.text'
                  }}
                />
              </TableContainer>
            </>
          )
        }
      </>
    );
  };

  return (
    <Box>
      <Box
        sx={{ p: { xs: 2, sm: 3 }, mb: 2, borderRadius: 3, background: theme.palette.mode == 'dark' ? '#32373a' :  'white', gap: 2, display: 'flex', justifyContent: 'space-between',
        boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: { xs: 'stretch', md: 'center' }
      }}
      >
        {
          isSmallScreen ? (
            <>
              <Typography variant="h5" sx={{ fontWeight: 700, flex: 1, textTransform: 'capitalize', color: 'background.text',  }}>
                Call Logs
              </Typography>
            </>
          ) : (
            <>
              <Typography variant="h4" fontWeight={700} sx={{ color: 'background.text'}}>Call Logs</Typography>
            </>
          )
        }
        <Box sx={{display:'flex',flexDirection:{xs:'column',md:'row'},gap:2 }} >
          <SearchInput value={searchTerm} onChange={handleSearch} />

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flex: 1 }}>
            <FormControl size="small" sx={{ minWidth:isSmallScreen ? '100%' : 180, }} style={{ maxWidth: 250 ,padding:0}}>
              <SelectInput
                label="Status"
                value={statusFilter}
                onChange={handleStatusFilterChange}
                options={[
                  { label: 'All', value: 'All' },
                  { label: 'Connected', value: 'connected' },
                  { label: 'Not Connected', value: 'not connected' },
                ]}
              />
            </FormControl>
          </Box>

        </Box>        
      </Box>

      <Paper elevation={2} sx={{ borderRadius: 3 }}>

        {
          isSmallScreen ? (
            <>
              <Tabs
                variant=''
                allowScrollButtonsMobile
                value={tabValue}
                onChange={handleTabChange}
                sx={{
                  borderBottom: 1,
                  borderColor: 'divider',
                  '& .MuiTab-root': {
                    fontWeight: 600,
                    textTransform: 'none',
                    fontSize: 16
                  }
                }}
              >
                <Tab
                  label={
                    <Box display="flex" alignItems="center" gap={1} sx={{ color: 'background.text' }}>
                      <PhoneIcon fontSize="small" />
                    </Box>
                  }
                />
                <Tab
                  label={
                    <Box display="flex" alignItems="center" gap={1} sx={{ color: 'background.text' }}>
                      <PhoneDisabledIcon fontSize="small" />
                    </Box>
                  }
                />
                <Tab
                  label={
                    <Box display="flex" alignItems="center" gap={1} sx={{ color: 'background.text' }}>
                      <CallMadeIcon fontSize="small" />
                    </Box>
                  }
                />

              </Tabs>
            </>
          ) : (
            <>
              <Box display="flex" justifyContent="space-between" alignItems="center">
                      <Tabs
                    variant='scrollable'
                    allowScrollButtonsMobile
                    value={tabValue}
                    onChange={handleTabChange}
                    sx={{
                      borderBottom: 1,
                      borderColor: 'divider',
                      '& .MuiTab-root': {
                        fontWeight: 600,
                        textTransform: 'none',
                        fontSize: 16
                      }
                    }}
                  >
                    <Tab
                      label={
                        <Box display="flex" alignItems="center" gap={1} sx={{ color: 'background.text' }}>
                          <PhoneIcon fontSize="small" />
                          Received Calls
                        </Box>
                      }
                    />
                    <Tab
                      label={
                        <Box display="flex" alignItems="center" gap={1} sx={{ color: 'background.text' }}>
                          <PhoneDisabledIcon fontSize="small" />
                          Missed Calls
                        </Box>
                      }
                    />
                    <Tab
                      label={
                        <Box display="flex" alignItems="center" gap={1} sx={{ color: 'background.text' }}>
                          <CallMadeIcon fontSize="small" />
                          Dialed Calls
                        </Box>
                      }
                    />

                  </Tabs>
                  
              </Box>
            </>
          )
        }


        <TabPanel value={tabValue} index={0}>
          {loading ? (
            <Box p={3} textAlign="center"><Typography sx={{ color: 'background.text' }}>Loading calls...</Typography></Box>
          ) : error ? (
            <Box p={3} textAlign="center"><Typography color="error">{error}</Typography></Box>
          ) : (
            renderCallTable(receivedCalls, true)
          )}
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
          {loading ? (
            <Box p={3} textAlign="center"><Typography sx={{ color: 'background.text' }}>Loading calls...</Typography></Box>
          ) : error ? (
            <Box p={3} textAlign="center"><Typography color="error">{error}</Typography></Box>
          ) : (
            renderCallTable(missedCalls, false)
          )}
        </TabPanel>
        <TabPanel value={tabValue} index={2}>
          {loading ? (
            <Box p={3} textAlign="center"><Typography sx={{ color: 'background.text' }}>Loading calls...</Typography></Box>
          ) : error ? (
            <Box p={3} textAlign="center"><Typography color="error">{error}</Typography></Box>
          ) : (
            renderCallTable(dialedCalls, true)
          )}
        </TabPanel>
      </Paper>


      {/* WhatsApp Confirmation Dialog */}
      <Dialog open={showWhatsAppDialog} onClose={handleCancelWhatsApp} maxWidth="sm" fullWidth>
        <DialogTitle>
          <Box display="flex" alignItems="center" gap={2}>
            <WhatsAppIcon sx={{ color: '#25D366', fontSize: 28 }} />
            <Typography variant="h6" fontWeight={600} sx={{ color: 'background.text' }}>
              Send WhatsApp Message
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          {selectedCall && (
            <Box>
              <Typography variant="body1" sx={{ mb: 2, color: 'background.text' }}>
                Are you sure you want to send a WhatsApp message to:
              </Typography>
              <Box sx={{ bgcolor: 'background.paper', p: 2, borderRadius: 2, mb: 2 }}>
                <Typography variant="subtitle1" fontWeight={600} color="primary">
                  {selectedCall.patient}
                </Typography>
                <Typography variant="body2" color="background.text">
                  {selectedCall.phone}
                </Typography>
                <Typography variant="body2" color="background.text">
                  Service: {selectedCall.service}
                </Typography>
              </Box>
              <Typography variant="body2" color="background.text">
                A default message will be sent asking them to contact us for their {selectedCall.service.toLowerCase()} request.
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelWhatsApp} color="inherit" sx={{ color: 'background.text' }}>
            Cancel
          </Button>
          <Button
            onClick={handleSendWhatsApp}
            variant="contained"
            sx={{
              bgcolor: '#25D366',
              '&:hover': { bgcolor: '#1ebe57' },
            }}
            startIcon={<WhatsAppIcon />}
          >
            Send WhatsApp
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} elevation={6} variant="filled" sx={{ fontSize: 16, fontWeight: 600, borderRadius: 2 }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default CallLogsPage; 